<script lang="ts">
import { tv } from 'tailwind-variants';
import { breadcrumbButtonFolded } from '#layers/ui/theme/components/_helpers';

const switcherButton = tv({
	base: 'min-w-0',
	variants: {
		folded: {
			true: breadcrumbButtonFolded,
			false: 'rounded-sm text-sm font-semibold block-7',
		},
	},
});
</script>

<script setup lang="ts">
import { useTextDirection } from '@vueuse/core';
import { computed } from 'vue';
import { useAppConfig } from '#app/config';
import DTextOverflow from '#layers/ui/components/TextOverflow.vue';

interface Props {
	label: string;
	pressed?: boolean;
	folded?: boolean;
}

const { folded = false } = defineProps<Props>();

const appConfig = useAppConfig();
const dir = useTextDirection();

const trailingIcon = computed(() => {
	if (!folded) return;
	return dir.value === 'rtl' ? appConfig.ui.icons.chevronLeft : appConfig.ui.icons.chevronRight;
});
</script>

<template>
	<DButton
		color="neutral"
		variant="ghost"
		:pressed
		:block="folded"
		:class="switcherButton({ folded })"
		:trailing-icon
		:ui="{
			base: 'flex min-w-0 items-center text-start',
			trailingIcon: 'size-4 flex-none shrink-0 text-toned',
		}"
	>
		<DTextOverflow :text="label" class="min-w-0 flex-1" />
	</DButton>
</template>
